export class Tracker {
    private startTime: number = Date.now();
    private currentView: string = 'none';

    constructor() {
        window.addEventListener('viewChanged', (e: any) => {
            this.sendAudit(); // Enviar data de la vista anterior
            this.currentView = e.detail;
            this.startTime = Date.now();
        });

        // Enviar datos antes de cerrar la pesta�a o recargar
        window.addEventListener('beforeunload', () => this.sendAudit());
    }

    private async sendAudit() {
        if (this.currentView === 'none') return;

        const duration = Math.round((Date.now() - this.startTime) / 1000);

        // Llamada as�ncrona "fire and forget" a Cloudflare Function
        fetch('/api/audit', {
            method: 'POST',
            body: JSON.stringify({
                view_id: this.currentView,
                time_seconds: duration
            }),
            headers: {
                'Content-Type': 'application/json'
            },
            keepalive: true // Crucial para asegurar el env�o al cambiar de p�gina
        }).catch(err => console.error('Audit no enviado:', err)); // Silenciamos el error en UI
    }
}